// extracted by css-extract-rspack-plugin
export default {"footerActions":"footerActions-f93yWC"};